export const primaryGreen = '#054321';
export const secondaryGreen = '#19A859';
export const primaryOrange = '#E94D29';
export const white = '#FFFFFF';
export const background = '#F7F7F7';